module.exports = __webpack_public_path__ + "img/Recurso 10@300x.4edc04a9.webp";